<div class="nd-wrap">

  <div class="nd-header">
    <button class="nd-back-btn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon> Volver
    </button>
    <div class="nd-header__actions">
      <button *ngIf="campaign?.status === 'DRAFT'" mat-stroked-button color="primary" (click)="goToEdit()">
        <mat-icon>edit</mat-icon> Editar
      </button>
      <button *ngIf="campaign?.status === 'SCHEDULED'" mat-stroked-button color="warn" (click)="cancelCampaign()">
        <mat-icon>cancel</mat-icon> Cancelar envío
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="nd-state">
    <div class="nd-spinner"></div><span>Cargando...</span>
  </div>
  <div *ngIf="errorMessage" class="nd-error">{{ errorMessage }}</div>

  <div *ngIf="campaign && !loading">

    <div class="nd-campaign-header">
      <h2 class="nd-campaign-header__title">{{ campaign.name }}</h2>
      <span class="nl-badge" [ngClass]="statusClass(campaign.status)">{{ statusLabel(campaign.status) }}</span>
    </div>

    <p class="nd-subject"><strong>Asunto:</strong> {{ campaign.subject }}</p>

    <div class="nd-meta-row">
      <span *ngIf="campaign.scheduledAt" class="nd-meta">
        <mat-icon>schedule</mat-icon> Programada: {{ campaign.scheduledAt | date:'dd/MM/yyyy HH:mm' }}
      </span>
      <span *ngIf="campaign.sentAt" class="nd-meta">
        <mat-icon>check_circle</mat-icon> Enviada: {{ campaign.sentAt | date:'dd/MM/yyyy HH:mm' }}
      </span>
    </div>

    <!-- Métricas -->
    <div class="nd-metrics" *ngIf="metrics">
      <div class="nd-metric">
        <div class="nd-metric__value">{{ metrics.total }}</div>
        <div class="nd-metric__label">Total</div>
      </div>
      <div class="nd-metric nd-metric--sent">
        <div class="nd-metric__value">{{ metrics.sent }}</div>
        <div class="nd-metric__label">Enviados</div>
      </div>
      <div class="nd-metric nd-metric--failed">
        <div class="nd-metric__value">{{ metrics.failed }}</div>
        <div class="nd-metric__label">Fallidos</div>
      </div>
      <div class="nd-metric nd-metric--pending">
        <div class="nd-metric__value">{{ metrics.pending }}</div>
        <div class="nd-metric__label">Pendientes</div>
      </div>
    </div>

    <div *ngIf="campaign.status === 'SENDING'" class="nd-sending-notice">
      <mat-icon>sync</mat-icon>
      Envío en curso — los datos se actualizan automáticamente cada 5 segundos.
    </div>

    <!-- Destinatarios -->
    <h3 class="nd-section-title">Destinatarios</h3>

    <div *ngIf="recipients.length === 0" class="nd-empty-msg">
      No hay destinatarios registrados todavía.
    </div>

    <div *ngIf="recipients.length > 0" class="nd-card">
      <table class="nd-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Intentos</th>
            <th>Enviado</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of recipients">
            <td>{{ r.email }}</td>
            <td>{{ r.recipientName || '—' }}</td>
            <td>
              <span class="nd-rec-badge" [ngClass]="recipientStatusClass(r.status)">
                {{ recipientStatusLabel(r.status) }}
              </span>
            </td>
            <td>{{ r.attempts }}</td>
            <td class="nd-table__date">{{ r.sentAt ? (r.sentAt | date:'dd/MM HH:mm') : '—' }}</td>
            <td class="nd-table__error">{{ r.errorMessage || '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="totalPages > 1" class="nd-pagination">
      <button mat-stroked-button (click)="prevPage()" [disabled]="page === 0">
        <mat-icon>chevron_left</mat-icon> Anterior
      </button>
      <span class="nd-pagination__info">Página {{ page + 1 }} de {{ totalPages }} ({{ totalElements }} destinatarios)</span>
      <button mat-stroked-button (click)="nextPage()" [disabled]="page >= totalPages - 1">
        Siguiente <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <h3 class="nd-section-title">Contenido del correo</h3>
    <div class="nd-content-preview" [innerHTML]="campaign.htmlContent"></div>

  </div>
</div>
